import { render, staticRenderFns } from "./ViewInfoDialog.vue?vue&type=template&id=40ef4884&scoped=true"
import script from "./ViewInfoDialog.vue?vue&type=script&lang=ts"
export * from "./ViewInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./ViewInfoDialog.vue?vue&type=style&index=0&id=40ef4884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef4884",
  null
  
)

export default component.exports